import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import Loader from "@/Layout/Loader";
import { useMenuItems } from "@/Layout/SideBar-Layout/Menu";
import usePermissions from "@/utils/hooks/usePermissions";
import { getFirstMenuLinkPath } from "@/utils/menuNavigation";
import { MADINA_HOME_ANALYTICS_PERMISSIONS } from "@/Pages/Makkah/MakkahDashboard/dashboardRoutePermissions";

const MadinaDashboard = lazy(() => import("@/Pages/MadinaDashboard/MadinaDashboard.jsx"));

export function MadinaHomeRoute() {
  const { hasAnyPermission } = usePermissions();
  const { madina } = useMenuItems();

  if (!hasAnyPermission(MADINA_HOME_ANALYTICS_PERMISSIONS)) {
    const to = getFirstMenuLinkPath(madina) || "/app/me";
    return <Navigate to={to} replace />;
  }

  return (
    <Suspense fallback={<Loader />}>
      <MadinaDashboard />
    </Suspense>
  );
}
